import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getResolveUrl } from 'utils';
import HelmetWrapper from 'components/HelmetWrapper';
import { CONTACT_US_ROUTE } from 'data/global';
import ContactUsForm from './components/ContactUsForm';

import './ContactUs.styles.scss';
import './ContactUs.styles.responsive.scss';

type ContactUsProps = {
  className?: string;
};

const ContactUs: React.FC<ContactUsProps> = (props) => {
  const { className } = props;

  const classes = classNames('contact-us', className);

  const { t } = useTranslation();

  const helmetUrl = getResolveUrl(CONTACT_US_ROUTE);
  const title = 'Contact Resolve | Business Sales Australia';
  const description =
    'Looking for a trusted partner to guide you through the buying or selling process? Contact Resolve today.';

  return (
    <div className={classes}>
      <HelmetWrapper title={title} description={description} url={helmetUrl} />

      <h1 className="contact-us__title" aria-label={t('contactUs')}>
        {t('contactUs')}
      </h1>

      <ContactUsForm />
    </div>
  );
};

export default ContactUs;
